import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type Problem as SchemaProblem } from '../schemas/Problem';
import { type StartPhoneVerificationProblemType as SchemaStartPhoneVerificationProblemType } from '../schemas/StartPhoneVerificationProblemType';
import { type StartPhoneVerificationResult as SchemaStartPhoneVerificationResult } from '../schemas/StartPhoneVerificationResult';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Initiates phone verification by sending a verification code to the user's phone number
 * @summary Start phone verification process
 */
export const StartPhoneVerificationContentType = '' as const;
export type StartPhoneVerificationRequest = undefined;
export type StartPhoneVerificationResponses = LinkCommonErrorResponses & {
    /**
     * @description Verification code was sent to the user
     */
    '200': {
        'application/json': SchemaStartPhoneVerificationResult;
    };
    /**
     * @description Bad request
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaStartPhoneVerificationProblemType;
        };
    };
};
export type StartPhoneVerificationResponseSuccess = StartPhoneVerificationResponses['200']['application/json'];
export type StartPhoneVerificationSearchParams = {
    signature: string;
};
export type StartPhoneVerificationPathParameters = {
    store_slug: string;
    order_id: string;
};
export const StartPhoneVerificationUrl = '/{store_slug}/orders/{order_id}/phone/verification/start' as const;
export const StartPhoneVerificationMethod = 'POST' as const;
export const getStartPhoneVerificationUrl = (params: StartPhoneVerificationPathParameters) =>
    StartPhoneVerificationUrl.replace(/\{(\w+)\}/g, (_match, param: keyof StartPhoneVerificationPathParameters) =>
        String(params[param])
    );
